// Copyright (c) 2018 Deere & Company

import MeasurementReading from '@deere/cps-it.warranty-model-factory/lib/measurement-reading';
import t from 'tcomb';

const LatestPerUnitMeasurements = t.list(MeasurementReading, 'LatestPerUnitMeasurements');

export const getDefaultState = () =>
    new LatestPerUnitMeasurements([]);

export default LatestPerUnitMeasurements;



// WEBPACK FOOTER //
// ./src/shared/state/latest-per-unit-measurements.js